<!-- prettier-ignore -->

  <ion-header no-border>
    <div class="cicerone-header" [ngClass]="{'no-touch': disableTouch()}">
      
      <div class="cicerone-header__logo">
        @if(!tools.isTechEditMode()){
            @if (!tools.isRegisterMode()){
               @if(showBackButton() || isBackDistributor()){
                <ion-icon (click)="goBack()" name="arrow-back-outline" attr.aria-label="{{ 'Atrás' | translate }}"></ion-icon>  
               }
            } 
            @if(rest?.device?.logoList?.primaryLogo?.value){
              <img 
                draggable="false" 
                [src]="rest?.device?.logoList?.primaryLogo?.value" 
                (click)="goToHome()" 
                (error)="tools.onImageError($event)" 
                alt="{{'Inicio' | translate}}" 
              />
            }
        }
        @else {
            <span>{{'Modo Edición' | translate}}</span>
        }
      </div>
  
      <div class="cicerone-header__fab">
        @if(tools.isTechEditMode()){
          <header-tech-update />
        }
  
        @if(!tools.isRegisterMode() && tools.isApp && !tools.isTechEditMode() && !tools.isTechMode()){
          <header-user-menu />
        }
  
        <header-languages [clientId]="currentClientId" />
  
        @if(tools.isTechMode()){
          <header-tech-logout />
        }
      </div>
  
    </div>
  </ion-header>

